import { render, staticRenderFns } from "./PositionsModal.vue?vue&type=template&id=6548d730&"
import script from "./PositionsModal.vue?vue&type=script&lang=js&"
export * from "./PositionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports